import {Levels} from "@/api/error";
import {RootState} from "../index";
import {BerechnungState} from "./berechnung";

export interface ErrorState {
    baujahr: boolean,
    gebaeudetyp: boolean,
    haustyp: boolean,
    sanitaerbereich: boolean,
    kuechengrundausstattung: boolean,
    elektrogeraete: boolean,
    fussboden: boolean,
    modernisierterBoden: boolean,
    terrasseBalkon: boolean,
    modernisierteFenster: boolean,
    abweichungen: boolean,
    fussbodenheizung: boolean,
    selectedBaujahrError: { [index:string] : Function },
    selectedGebaeudetypError: { [index:string] : Function },
    selectedHaustypError: { [index:string] : Function },
    selectedSanitaerbereichError: Array<{ [index:string] : Function }>,
    selectedKuechengrundausstattungError: { [index:string] : Function },
    selectedElektrogeraeteError: Array<{ [index:string] : Function }>,
    selectedFussbodenError: { [index:string] : Function },
    selectedModernisierterBodenError: { [index:string] : Function },
    selectedFussbodenheizungError: { [index:string] : Function },
    selectedTerrasseBalkonError: { [index:string] : Function },
    selectedModernisierteFensterError: { [index:string] : Function },
    selectedAbweichungenErrors: Array<{ [index:string] : Function }>
}

export default {
    namespaced: true,
    state: {
        baujahr: false,
        gebaeudetyp: false,
        haustyp: false,
        sanitaerbereich: false,
        kuechengrundausstattung: false,
        elektrogeraete: false,
        fussboden: false,
        modernisierterBoden: false,
        terrasseBalkon: false,
        modernisierteFenster: false,
        abweichungen: false,
        fussbodenheizung: false,
        selectedBaujahrError: {},
        selectedGebaeudetypError: {},
        selectedHaustypError: {},
        selectedSanitaerbereichError: [],
        selectedKuechengrundausstattungError: {},
        selectedElektrogeraeteError: [],
        selectedFussbodenError: {},
        selectedModernisierterBodenError: {},
        selectedFussbodenheizungError: {},
        selectedTerrasseBalkonError: {},
        selectedModernisierteFensterError: {},
        selectedAbweichungenErrors: []
    } as ErrorState,
    getters: {
        CALCULATION_HAS_ERROR(state: ErrorState){
            return (Object.keys(state) as Array<keyof typeof state>).filter(key => !key.startsWith('selected')).some((category: keyof ErrorState) => state[category])
        }
    },
    mutations: {
        SET_BAUJAHR_ERROR(state:ErrorState, baujahr:boolean) {
            state.baujahr = baujahr
        },
        SET_SELECTED_BAUJAHR_ERROR(state:ErrorState, selectedBaujahrError:{ [index:string] : Function }) {
            state.selectedBaujahrError = selectedBaujahrError
        },
        SET_GEBAEUDETYP_ERROR(state:ErrorState, gebaeudetyp:boolean) {
            state.gebaeudetyp = gebaeudetyp
        },
        SET_SELECTED_GEBAEUDETYP_ERROR(state:ErrorState, selectedGebaeudetypError:{ [index:string] : Function }) {
            state.selectedGebaeudetypError = selectedGebaeudetypError
        },
        SET_HAUSTYP_ERROR(state:ErrorState, haustyp:boolean) {
            state.haustyp = haustyp
        },
        SET_SELECTED_HAUSTYP_ERROR(state:ErrorState, selectedHaustypError:{ [index:string] : Function }) {
            state.selectedHaustypError = selectedHaustypError
        },
        SET_SANITAERBEREICH_ERROR(state:ErrorState, sanitaerbereich:boolean) {
            state.sanitaerbereich = sanitaerbereich
        },
        SET_SELECTED_SANITAERBEREICH_ERROR(state:ErrorState, selectedSanitaerbereichError:Array<{ [index:string] : Function }>) {
            state.selectedSanitaerbereichError = selectedSanitaerbereichError
        },
        SET_KUECHENGRUNDAUSSTATTUNG_ERROR(state:ErrorState, kuechengrundausstattung:boolean) {
            state.kuechengrundausstattung = kuechengrundausstattung
        },
        SET_SELECTED_KUECHENGRUNDAUSSTATTUNG_ERROR(state:ErrorState, selectedKuechengrundausstattungError:{ [index:string] : Function }) {
            state.selectedKuechengrundausstattungError = selectedKuechengrundausstattungError
        },
        SET_ELEKTROGERAETE_ERROR(state:ErrorState, elektrogeraete:boolean) {
            state.elektrogeraete = elektrogeraete
        },
        SET_SELECTED_ELEKTROGERAETE_ERROR(state:ErrorState, selectedElektrogeraeteError:Array<{ [index:string] : Function }>) {
            state.selectedElektrogeraeteError = selectedElektrogeraeteError
        },
        SET_FUSSBODEN_ERROR(state:ErrorState, fussboden:boolean) {
            state.fussboden = fussboden
        },
        SET_SELECTED_FUSSBODEN_ERROR(state:ErrorState, selectedFussbodenError:{ [index:string] : Function }) {
            state.selectedFussbodenError = selectedFussbodenError
        },
        SET_MODERNISIERTERBODEN_ERROR(state:ErrorState, modernisierterBoden:boolean) {
            state.modernisierterBoden = modernisierterBoden
        },
        SET_FUSSBODENHEIZUNG_ERROR(state:ErrorState, fussbodenheizung:boolean) {
            state.fussbodenheizung = fussbodenheizung
        },
        SET_SELECTED_FUSSBODENHEIZUNG_ERROR(state:ErrorState, selectedFussbodenheizungError:{ [index:string] : Function }) {
            state.selectedFussbodenheizungError = selectedFussbodenheizungError
        },
        SET_TERRASSEBALKON_ERROR(state:ErrorState, terrasseBalkon:boolean) {
            state.terrasseBalkon = terrasseBalkon
        },
        SET_SELECTED_TERRASSEBALKON_ERROR(state:ErrorState, selectedTerrasseBalkonError:{ [index:string] : Function }) {
            state.selectedTerrasseBalkonError = selectedTerrasseBalkonError
        },
        SET_ABWEICHUNGEN_ERROR(state:ErrorState, abweichungen:boolean) {
            state.abweichungen = abweichungen
        },
        SET_SELECTED_ABWEICHUNGEN_ERROR(state:ErrorState, selectedAbweichungenErrors:Array<{ [index:string] : Function }>) {
            state.selectedAbweichungenErrors = selectedAbweichungenErrors
        },
        SET_MODERNISIERTEFENSTER_ERROR(state:ErrorState, modernisierteFenster:boolean) {
            state.modernisierteFenster = modernisierteFenster
        },
        SET_SELECTED_MODERNISIERTEFENSTER_ERROR(state:ErrorState, selectedModernisierteFensterError:{ [index:string] : Function }) {
            state.selectedModernisierteFensterError = selectedModernisierteFensterError
        }
    },
    actions: {
        CHECK_BAUJAHR_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedBaujahrError
            // check if one of the selected values from other components is matching in error function of selection
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for baujahr")
                commit('SET_BAUJAHR_ERROR', true)
            }else{
                commit('SET_BAUJAHR_ERROR', false)
            }
        },
        CHECK_GEBAEUDETYP_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedGebaeudetypError
            // check if one of the selected values from other components is matching in error function of selection
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for gebaeudetyp")
                commit('SET_GEBAEUDETYP_ERROR', true)
            }else{
                commit('SET_GEBAEUDETYP_ERROR', false)
            }
        },
        CHECK_HAUSTYP_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedHaustypError
            // check if one of the selected values from other components is matching in error function of selection
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for haustyp")
                commit('SET_HAUSTYP_ERROR', true)
            }else{
                commit('SET_HAUSTYP_ERROR', false)
            }
        },
        CHECK_SANITAERBEREICH_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const errors = state.selectedSanitaerbereichError
            /*
             * check if one of the selected values from other components is matching in one of
             * the error functions of multiple choice selection (= selected...Error)
             */
            if(errors && errors.some(error => (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true))){
                console.log("found error for sanitaerbereich")
                commit('SET_SANITAERBEREICH_ERROR', true)
            }else{
                commit('SET_SANITAERBEREICH_ERROR', false)
            }
        },
        CHECK_KUECHENGRUNDAUSSTATTUNG_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedKuechengrundausstattungError
            /*
             * check if one of the selected values from other components is matching in error
             * function of selection (= selected...Error)
             */
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for kuechengrundausstattung")
                commit('SET_KUECHENGRUNDAUSSTATTUNG_ERROR', true)
            }else{
                commit('SET_KUECHENGRUNDAUSSTATTUNG_ERROR', false)
            }
        },
        CHECK_ELEKTROGERAETE_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const errors = state.selectedElektrogeraeteError
            // check if one of the selected values from other components is matching in error function of selection
            if(errors && errors.some(error => (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true))){
                console.log("found error for elektrogeraete")
                commit('SET_ELEKTROGERAETE_ERROR', true)
            }else{
                commit('SET_ELEKTROGERAETE_ERROR', false)
            }
        },
        CHECK_FUSSBODEN_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedFussbodenError
            // check if one of the selected values from other components is matching in error function of selection
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for fussboden")
                commit('SET_FUSSBODEN_ERROR', true)
            }else{
                commit('SET_FUSSBODEN_ERROR', false)
            }
        },
        CHECK_MODERNISIERTERBODEN_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedModernisierterBodenError
            // check if one of the selected values from other components is matching in error function of selection
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for modernisierterBoden")
                commit('SET_MODERNISIERTERBODEN_ERROR', true)
            }else{
                commit('SET_MODERNISIERTERBODEN_ERROR', false)
            }
        },
        CHECK_FUSSBODENHEIZUNG_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedFussbodenheizungError
            // check if one of the selected values from other components is matching in error function of selection
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for fussbodenheizung")
                commit('SET_FUSSBODENHEIZUNG_ERROR', true)
            }else{
                commit('SET_FUSSBODENHEIZUNG_ERROR', false)
            }
        },
        CHECK_TERRASSEBALKON_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedTerrasseBalkonError
            // check if one of the selected values from other components is matching in error function of selection
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for terrasseBalkon")
                commit('SET_TERRASSEBALKON_ERROR', true)
            }else{
                commit('SET_TERRASSEBALKON_ERROR', false)
            }
        },
        CHECK_MODERNISIERTEFENSTER_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const error = state.selectedModernisierteFensterError
            // check if one of the selected values from other components is matching in error function of selection
            if(error && (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true)){
                console.log("found error for moderniesiertefenster")
                commit('SET_MODERNISIERTEFENSTER_ERROR', true)
            }else{
                commit('SET_MODERNISIERTEFENSTER_ERROR', false)
            }
        },
        CHECK_ABWEICHUNGEN_ERROR({state, commit, rootState}: {state: ErrorState, commit: Function, rootState: RootState}){
            const errors = state.selectedAbweichungenErrors
            // check if one of the selected values from other components is matching in error function of selection
            if(errors && errors.some(error => (Object.keys(error) as Array<keyof BerechnungState>).map(key => error[key](rootState.berechnung[key])).some(el => el === true))){
                console.log("found error for abweichungen")
                commit('SET_ABWEICHUNGEN_ERROR', true)
            }else{
                commit('SET_ABWEICHUNGEN_ERROR', false)
            }
        },
        RESET_ERRORS({ commit }: { commit: Function }){
            commit('SET_BAUJAHR_ERROR', false)
            commit('SET_GEBAEUDETYP_ERROR', false)
            commit('SET_HAUSTYP_ERROR', false)
            commit('SET_SANITAERBEREICH_ERROR', false)
            commit('SET_KUECHENGRUNDAUSSTATTUNG_ERROR', false)
            commit('SET_ELEKTROGERAETE_ERROR', false)
            commit('SET_FUSSBODEN_ERROR', false)
            commit('SET_MODERNISIERTERBODEN_ERROR', false)
            commit('SET_TERRASSEBALKON_ERROR', false)
            commit('SET_ABWEICHUNGEN_ERROR', false)
            commit('SET_SELECTED_BAUJAHR_ERROR', {})
            commit('SET_SELECTED_GEBAEUDETYP_ERROR', {})
            commit('SET_SELECTED_HAUSTYP_ERROR', {})
            commit('SET_SELECTED_SANITAERBEREICH_ERROR', [])
            commit('SET_SELECTED_KUECHENGRUNDAUSSTATTUNG_ERROR', {})
            commit('SET_SELECTED_ELEKTROGERAETE_ERROR', [])
            commit('SET_SELECTED_FUSSBODEN_ERROR', {})
            commit('SET_SELECTED_MODERNISIERTERBODEN_ERROR', {})
            commit('SET_SELECTED_TERRASSEBALKON_ERROR', {})
            commit('SET_SELECTED_MODERNISIERTEFENSTER_ERROR', {})
            commit('SET_SELECTED_FUSSBODENHEIZUNG_ERROR', {})
            commit('SET_SELECTED_ABWEICHUNGEN_ERROR', [])
        },
        SET_ERRORS({ commit }: { commit: Function}, payload: { errors:ErrorState }) {
            commit('SET_BAUJAHR_ERROR', payload.errors.baujahr)
            commit('SET_GEBAEUDETYP_ERROR', payload.errors.gebaeudetyp)
            commit('SET_HAUSTYP_ERROR', payload.errors.haustyp)
            commit('SET_SANITAERBEREICH_ERROR', payload.errors.sanitaerbereich)
            commit('SET_KUECHENGRUNDAUSSTATTUNG_ERROR', payload.errors.kuechengrundausstattung)
            commit('SET_ELEKTROGERAETE_ERROR', payload.errors.elektrogeraete)
            commit('SET_FUSSBODEN_ERROR', payload.errors.fussboden)
            commit('SET_MODERNISIERTERBODEN_ERROR', payload.errors.modernisierterBoden)
            commit('SET_TERRASSEBALKON_ERROR', payload.errors.terrasseBalkon)
            commit('SET_ABWEICHUNGEN_ERROR', payload.errors.abweichungen)
            commit('SET_SELECTED_BAUJAHR_ERROR', payload.errors.selectedBaujahrError)
            commit('SET_SELECTED_GEBAEUDETYP_ERROR', payload.errors.selectedGebaeudetypError)
            commit('SET_SELECTED_HAUSTYP_ERROR', payload.errors.selectedHaustypError)
            commit('SET_SELECTED_SANITAERBEREICH_ERROR', payload.errors.selectedSanitaerbereichError)
            commit('SET_SELECTED_KUECHENGRUNDAUSSTATTUNG_ERROR', payload.errors.selectedKuechengrundausstattungError)
            commit('SET_SELECTED_ELEKTROGERAETE_ERROR', payload.errors.selectedElektrogeraeteError)
            commit('SET_SELECTED_FUSSBODEN_ERROR', payload.errors.selectedFussbodenError)
            commit('SET_SELECTED_MODERNISIERTERBODEN_ERROR', payload.errors.selectedModernisierterBodenError)
            commit('SET_SELECTED_TERRASSEBALKON_ERROR', payload.errors.selectedTerrasseBalkonError)
            commit('SET_SELECTED_MODERNISIERTEFENSTER_ERROR', payload.errors.selectedModernisierterBodenError)
            commit('SET_SELECTED_FUSSBODENHEIZUNG_ERROR', payload.errors.selectedFussbodenheizungError)
            commit('SET_SELECTED_ABWEICHUNGEN_ERROR', payload.errors.selectedAbweichungenErrors)
        }
    }
}